import { API_ROUTES } from '@/constants/apiRoutes';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { SubDomainDetailResponse, SubDomainParams } from './subDomain.types';

export const getSubDomainDetail = (client: AxiosInstance) => async (params?: SubDomainParams) => {
  return (await client.get<SubDomainDetailResponse>(API_ROUTES.GET_SUB_DOMAIN_DETAILS, { params })).data;
};

export const subDomainQueries = {
  all: () => ['subDomain'],

  detail: (params?: SubDomainParams) =>
    queryFactoryOptions<SubDomainDetailResponse>({
      queryKey: [...subDomainQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getSubDomainDetail(client)(params),
    }),
};
